import Vue from 'vue';
import axios from 'axios';

export default Vue.component('order-detail', {
    data: () => ({
        axe: axios.create({
            baseURL: '/mywecycle/order'
        }),
        targetLines: null,
        amountOfLines: null,
        totalWeight: null,
        loading: false
    }),
    methods: {
        handleClick(event) {
            // Check for the right element
            if (event.target.matches('[data-divide-weight]')) {
                this.openModal(event.target.dataset.divideWeight, event);
            }
        },
        openModal(type, event) {
            // Set target lines
            this.targetLines = event.target.closest('tbody').querySelectorAll('input[id*="' + type + '"]:not([readonly])');
            // Open modal
            window.$('#modal-divide-total-weight').modal('show');
        },
        divideWeight() {
            const params = {
                number: this.targetLines.length,
                totalWeight: parseInt(this.totalWeight)
            }

            let response;
            this.axe.get("/CollectionResourceDivideWeight", { params })
            .then((resp) => {
                response = resp.data;

                // Fill divided weights
                response.dividedWeights.forEach((w, i) => {
                    this.targetLines[i].value = w;
                });

                // Close modal
                window.$('#modal-divide-total-weight').modal('hide');

                // Clear total weight
                this.totalWeight = null;

                // Reset validation
                this.$refs.divideTotalWeight.reset();
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
        }
    }
});